export enum SDSToastType {
  Info = 'Info',
  Success = 'Success',
  Warning = 'Warning',
  Error = 'Error',
}

export interface SDSToastData {
  id: string;
  message: string;
  type: SDSToastType;
}
